module.exports = __webpack_public_path__ + "static/media/GLORY_4472.26650662.jpg";